import { createSelector } from 'reselect';

import { RootState } from 'redux/store';

export const getheaderSelector = (state: RootState) => state.header;

export const getHeaderClasses = createSelector(
  [getheaderSelector],
  headerState => headerState.classes
);

export const getHeaderActiveClass = createSelector(
  [getheaderSelector],
  headerState => headerState.active
);
